import React from 'react';
import { TableRow, TableCell } from '@mui/material';

const BillingSummaryTableRow = ({
  id,
  date,
  invoiceNo,
  name,
  COO,
  paidDate,
  paymentType,
  suffix,
  setupFees,
  licenceFees,
  messages,
  replies,
  messageFees,
  totalFees,
  gst,
  surcharge,
  total,
}) => (
  <TableRow
    key={`summary_${id}`}
    sx={{
      whiteSpace: 'nowrap',
      '& > .MuiTableCell-root:not(:first-of-type)': {
        textAlign: 'right',
      },
    }}>
    <TableCell>{date}</TableCell>
    <TableCell>{invoiceNo}</TableCell>
    <TableCell>{name}</TableCell>
    <TableCell>{COO}</TableCell>
    <TableCell>{paidDate}</TableCell>
    <TableCell>{paymentType}</TableCell>
    <TableCell>{suffix}</TableCell>
    <TableCell>{setupFees}</TableCell>
    <TableCell>{licenceFees}</TableCell>
    <TableCell>{messages}</TableCell>
    <TableCell>{replies}</TableCell>
    <TableCell>{messageFees}</TableCell>
    <TableCell>{totalFees}</TableCell>
    <TableCell>{gst}</TableCell>
    <TableCell>{surcharge}</TableCell>
    <TableCell>{total}</TableCell>
  </TableRow>
);

export default BillingSummaryTableRow;
